module.exports = __webpack_public_path__ + "static/img/pengu.2ce9e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/hero/pengu.png
// module id = NtbP
// module chunks = 35